import { GridColumn } from '@grid/abstractions';

export function filterByFilterableColumn(column: GridColumn): boolean {
  return !!column.isFilterable && !!column.filterableColumn;
}
